import { faker } from "@faker-js/faker";
import type { Menu, Permission, Role, User } from "#/entity";
import { PermissionType } from "#/enum";

const { MENU, CATALOGUE } = PermissionType;

export const DB_MENU: Menu[] = [
	// 工作台
	{
		id: "workbench",
		parentId: "",
		name: "工作台",
		code: "workbench",
		icon: "local:ic-workbench",
		type: MENU,
		path: "/workbench",
		component: "/pages/dashboard/workbench",
	},
	// 用户
	{
		id: "users",
		parentId: "",
		name: "用户",
		code: "users",
		icon: "mingcute:user-2-fill",
		type: MENU,
		path: "/users",
		component: "/pages/users",
	},
	// 订单
	{
		id: "subscriptions",
		parentId: "",
		name: "订阅信息",
		code: "subscriptions",
		icon: "mingcute:shopping-cart-2-fill",
		type: MENU,
		path: "/subscriptions",
		component: "/pages/subscriptions",
	},
	// Stripe交易
	{
		id: "stripe-transactions",
		parentId: "",
		name: "Stripe交易",
		code: "stripe-transactions",
		icon: "mingcute:currency-dollar-2-fill",
		type: MENU,
		path: "/stripe/transactions",
		component: "/pages/stripe/transactions",
	},
	// 生成
	{
		id: "generations",
		parentId: "",
		name: "生成",
		code: "generations",
		icon: "mingcute:magic-2-fill",
		type: MENU,
		path: "/generations",
		component: "/pages/generations",
	},
	// Blog
	{
		id: "blog",
		parentId: "",
		name: "Blog",
		code: "blog",
		icon: "mingcute:pencil-fill",
		type: MENU,
		path: "/blog",
		component: "/pages/blog",
	},
	// 活动管理
	{
		id: "activities",
		parentId: "",
		name: "活动管理",
		code: "activities",
		icon: "mingcute:calendar-star-fill",
		type: MENU,
		path: "/activities",
		component: "/pages/management/activities",
	},
	// 日志管理分组
	{
		id: "logs",
		parentId: "",
		name: "日志管理",
		code: "logs",
		icon: "mingcute:file-chart-fill",
		type: CATALOGUE,
		path: "/logs",
	},
	{
		id: "request-logs",
		parentId: "logs",
		name: "请求日志",
		code: "request-logs",
		icon: "mingcute:file-text-fill",
		type: MENU,
		path: "/logs/requests",
		component: "/pages/logs/requests",
	},
	{
		id: "email-logs",
		parentId: "logs",
		name: "邮件日志",
		code: "email-logs",
		icon: "mingcute:mail-fill",
		type: MENU,
		path: "/logs/emails",
		component: "/pages/management/logs/emails",
	},
	// 价格计划管理
	{
		id: "pricing",
		parentId: "",
		name: "价格计划",
		code: "pricing",
		icon: "mingcute:price-tag-fill",
		type: MENU,
		path: "/pricing",
		component: "/pages/management/pricing",
	},
	// Sitemap 管理
	{
		id: "site-sitemap",
		parentId: "",
		name: "Sitemap",
		code: "site-sitemap",
		icon: "mingcute:earth-fill",
		type: MENU,
		path: "/site/sitemap",
		component: "/pages/management/sitemap",
	},
	// 版本管理
	{
		id: "changelog",
		parentId: "",
		name: "版本管理",
		code: "changelog",
		icon: "mingcute:version-fill",
		type: MENU,
		path: "/changelog",
		component: "/pages/management/changelog",
	},
	// 抽奖日志
	{
		id: "roulette-logs",
		parentId: "",
		name: "抽奖日志",
		code: "roulette-logs",
		icon: "mingcute:celebrate-fill",
		type: MENU,
		path: "/roulette/logs",
		component: "/pages/management/roulette",
	},
];

export const DB_USER: User[] = [
	{
		id: "user_admin_id",
		username: "admin",
		password: "demo1234",
		avatar: faker.image.avatarGitHub(),
		email: "admin@slash.com",
	},
	{
		id: "user_test_id",
		username: "test",
		password: "demo1234",
		avatar: faker.image.avatarGitHub(),
		email: "test@slash.com",
	},
	{
		id: "user_guest_id",
		username: "guest",
		password: "demo1234",
		avatar: faker.image.avatarGitHub(),
		email: "guest@slash.com",
	},
];

export const DB_ROLE: Role[] = [
	{ id: "role_admin_id", name: "admin", code: "SUPER_ADMIN" },
	{ id: "role_test_id", name: "test", code: "TEST" },
];

export const DB_PERMISSION: Permission[] = [
	{ id: "permission_create", name: "permission-create", code: "permission:create" },
	{ id: "permission_read", name: "permission-read", code: "permission:read" },
	{ id: "permission_update", name: "permission-update", code: "permission:update" },
	{ id: "permission_delete", name: "permission-delete", code: "permission:delete" },
];

export const DB_USER_ROLE = [
	{ id: "user_admin_role_admin", userId: "user_admin_id", roleId: "role_admin_id" },
	{ id: "user_test_role_test", userId: "user_test_id", roleId: "role_test_id" },
];

export const DB_ROLE_PERMISSION = [
	{ id: faker.string.uuid(), roleId: "role_admin_id", permissionId: "permission_create" },
	{ id: faker.string.uuid(), roleId: "role_admin_id", permissionId: "permission_read" },
	{ id: faker.string.uuid(), roleId: "role_admin_id", permissionId: "permission_update" },
	{ id: faker.string.uuid(), roleId: "role_admin_id", permissionId: "permission_delete" },

	{ id: faker.string.uuid(), roleId: "role_test_id", permissionId: "permission_read" },
	{ id: faker.string.uuid(), roleId: "role_test_id", permissionId: "permission_update" },
];
